import transEnumsI18n from "./transEnumsI18n";
import getDiffFormatValue from "./getDiffFormatValue";
import type { Config, EnumItem } from "../type";
import { getT } from "@/utils/intlUtils";

const getMapEnums = (config: Config, pointedEnum: EnumItem[] = []) => {
  const { keyFormat, omit = [], isAll } = config;
  const map = new Map();

  if (isAll) {
    const t = getT();
    map.set("", { text: t("全部") });
  }

  pointedEnum.forEach((item) => {
    const current = {
      text: transEnumsI18n(item.groupCode, item.value),
    };
    const value = getDiffFormatValue(item.value, keyFormat);

    map.set(value, current);
  });

  if (omit.length !== 0) {
    omit.forEach((x) => {
      map.delete(x);
    });
  }
  return map;
};

export default getMapEnums;
